import { render, staticRenderFns } from "./AppServices.vue?vue&type=template&id=85fe6e78&scoped=true&"
import script from "./AppServices.vue?vue&type=script&lang=js&"
export * from "./AppServices.vue?vue&type=script&lang=js&"
import style0 from "./AppServices.vue?vue&type=style&index=0&id=85fe6e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe6e78",
  null
  
)

export default component.exports